// @codekit-prepend "_nav.js";
// @codekit-prepend "_intro.js";
// @codekit-prepend "_dialog.js";
// @codekit-prepend "_carousel.js";
import vhCheck from './_vhcheck';
import app from './_app'
import {navActions} from './_nav'
import {initDialog, toggleDialog, closeDialog} from './_dialog'
import { introAnimation } from './_intro';

vhCheck();
var scrollPosTop;
var $scrollWrapper;

(function ($) {

	'use strict';

	$(document).ready(function() {

		var path = document.location.pathname;
		if (path.endsWith('/'))
			path = path.substring(0, path.length - 1);
		console.log("Running app for path:", path)
		app.run(path);

		$scrollWrapper = $('.jsScrollWrapper');

		if(!Modernizr.svg) {
		    $('.jsLogo').attr('src', function() {
		        return $(this).attr('src').replace('.svg', '.png');
		    });
		}

		navActions();
		checkScrollTop();

		$('.jsRouteHome').on('click', function(event) {
			$('.jsLogo').stop(true).fadeTo(200, 0, function() {});
			$('.l-intro-wrapper').removeClass('is-hidden');
			$scrollWrapper.animate({scrollTop: 0}, 0);
			swipeDisabled = true;
			introAnimation();
		});


		$scrollWrapper.on('scroll', function(event) {
			checkScrollTop();			
		});

		function checkScrollTop() {
			var scroll = $scrollWrapper.scrollTop();
			if (scroll < 10) scrollPosTop = true
				else scrollPosTop = false
		}

	});
	
})(jQuery);
